<template>
  <modal name="modalChangeTimeEvent" class="modal-submit-drafts" :width="'35%'" :height="'auto'" :scrollable="true" @before-open="beforeOpen" @before-close="beforeClose">
    <div class="modal-header border-0 justify-content-end pb-0">
      <div class="modal-close-img" @click="onCancel()" @mouseover="isHoverClose = true"
           @mouseleave="isHoverClose = false">
        <img src="../../../static/img/info-modal-close.svg" alt="close" v-if="!isHoverClose" class="cursor-pointer">
        <img src="../../../static/img/info-modal-close-hover.svg" alt="close" v-if="isHoverClose" class="cursor-pointer">
      </div>
    </div>
    <div class="main-content">
      <p class="text-question">Are you sure you want to change event start/end time? All scheduled appointments within this event will be canceled.</p>
      <p class="text-description"><b>Members will receive a cancellation email.</b></p>
      <div class="btn-container">
        <b-button class="btn-cancel" @click="onCancel">
          Cancel
        </b-button>
        <b-button class="btn-submit" @click="onSubmit" :disabled="loading">
          <b-spinner v-if="loading"></b-spinner>
          Submit
        </b-button>
      </div>
    </div>
  </modal>
</template>
<script>
export default {
  name: 'ModalChangeTimeEvent',
  props: {
    onUpdateEventAction: Function,
    loading: Boolean
  },
  methods: {
    onCancel () {
      this.$modal.hide('modalChangeTimeEvent');
    },
    onSubmit () {
      this.onUpdateEventAction();
    }
  }
}
</script>


// WEBPACK FOOTER //
// ModalChangeTimeEvent.vue?262a08eb